import { storage } from "./storage";
import { HARI_LIBUR_2026 } from "../data/hariLiburData";

const KEY = "irbansus_hari_libur";
const VERSION_KEY = "irbansus_hari_libur_version";
const VERSION = 1;

export function loadHariLibur() {
  const v = storage.get(VERSION_KEY, null);
  const stored = storage.get(KEY, null);
  if (!stored || v !== VERSION) {
    const seed = [...HARI_LIBUR_2026];
    storage.set(KEY, seed);
    storage.set(VERSION_KEY, VERSION);
    return seed;
  }
  return Array.isArray(stored) ? stored : [];
}

export function saveHariLibur(list) {
  storage.set(KEY, list);
}

export function addHariLibur(list, tanggal, keterangan) {
  if (!tanggal) return list;
  const exists = list.some((h) => h.tanggal === tanggal);
  if (exists) return list.map((h) => (h.tanggal === tanggal ? { ...h, keterangan } : h));
  return [...list, { tanggal, keterangan: keterangan || "Libur" }].sort((a, b) =>
    a.tanggal.localeCompare(b.tanggal),
  );
}

export function removeHariLibur(list, tanggal) {
  return list.filter((h) => h.tanggal !== tanggal);
}
